import Plausible from 'plausible-tracker'

const plausible = Plausible();

plausible.trackPageview();
plausible.enableAutoOutboundTracking();
